import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Brand } from "@/components/Brand";
import { LogOut, LayoutDashboard } from "lucide-react";

export function Layout({ children }) {
  const { user, subscription, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 border-b border-border bg-white/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3.5">
          <Link to="/" data-testid="brand-home-link">
            <Brand />
          </Link>

          <div className="flex items-center gap-3">
            {subscription && (
              <div data-testid="usage-pill" className="hidden rounded-full border border-border bg-secondary px-3 py-1.5 text-xs font-medium text-secondary-foreground sm:block">
                {subscription.tier === "pro" ? "Pro" : "Trial"} · {subscription.letters_used}/{subscription.letters_limit} letters
              </div>
            )}
            <Button variant="ghost" size="sm" onClick={() => navigate("/")} data-testid="nav-dashboard-btn" className="gap-1.5">
              <LayoutDashboard className="h-4 w-4" /> Dashboard
            </Button>
            <div className="hidden text-right sm:block">
              <div className="text-sm font-medium text-primary">{user?.name}</div>
              <div className="text-[11px] uppercase tracking-wide text-muted-foreground">{user?.role}</div>
            </div>
            <Button variant="outline" size="icon" onClick={doLogout} data-testid="logout-btn" aria-label="Log out">
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-6 py-8">{children}</main>
    </div>
  );
}
